import { z } from 'zod';
import { issueLineRequestSchema } from './issuance.js';
/**
 * Form templates (owner, 2026-09-13): a named list of lines that prefills
 * the issue and bulk-issue wizards. Managed by admin and csm,
 * usable by anyone who may issue. A template names items, quantities and
 * conditions — never a serial: a serialized line means "one unit each,
 * picked at issue time", the same rule bulk issue applies. The target
 * (soldier, team, platoon, company) is chosen at issue time and is not
 * stored here.
 */
export const MAX_TEMPLATES = 100;
export const templateLineSchema = issueLineRequestSchema.omit({ inventoryUnitId: true }).strict();
export const formTemplateSchema = z.object({
    id: z.string().min(1),
    name: z.string().min(1).max(80),
    lines: z.array(templateLineSchema).min(1).max(20),
    active: z.boolean(),
    createdBy: z.string().min(1),
    createdAt: z.string().nullable(),
    updatedAt: z.string().nullable(),
});
/** POST /api/templates */
export const createTemplateRequestSchema = z.object({
    name: z.string().trim().min(1).max(80),
    lines: z.array(templateLineSchema).min(1).max(20),
});
/** PATCH /api/templates/:id — no delete: a template that issued forms stays readable in the ledger's context. */
export const updateTemplateRequestSchema = z
    .object({
    name: z.string().trim().min(1).max(80),
    lines: z.array(templateLineSchema).min(1).max(20),
    active: z.boolean(),
})
    .partial()
    .refine((b) => Object.keys(b).length > 0, { message: 'At least one field must be supplied' });
/** GET /api/templates?all=true — active only by default; the storeroom's editor asks for all. */
export const templatesQuerySchema = z.object({
    all: z
        .enum(['true', 'false'])
        .default('false')
        .transform((v) => v === 'true'),
});
export const templatesResponseSchema = z.object({ templates: z.array(formTemplateSchema) });
export const templateResponseSchema = z.object({ template: formTemplateSchema });
//# sourceMappingURL=templates.js.map